import React from 'react';

export default function Loading({ additionalData }: {
  additionalData: {
    hitClasses?: string;
    backgroundColor?: string;
  };
}) {
  return (
    <div className="flex gap-8 overflow-hidden w-full!">
      {Array.from({ length: 10 }, (_, index) => (
        <div key={index} className={`${additionalData.hitClasses ?? ''} shrink-0 aspect-10/13 max-w-40.75 xs:max-w-60 md:max-w-97.5 overflow-hidden`}>
          <div
            className={`group/card ${additionalData.backgroundColor ?? 'bg-gray-100'} w-full block h-full p-3 pt-12.25 lg:p-6 lg:pt-15.25 flex flex-col gap-4 w-full h-full animate-pulse`}
          >
            <div className="block bg-gray-300 aspect-square w-full relative overflow-hidden" />
            <div className="flex flex-col items-center justify-center gap-1 lg:gap-2">
              <div className="bg-gray-300 w-full h-6" />
              <div className="bg-gray-300 w-full h-6" />
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
